export default __webpack_public_path__ + "media/images/manual/joanr/07-2423322f93f3da1d403c845dd0bd7d14.png";